import { render, staticRenderFns } from "./b6Step.vue?vue&type=template&id=5ca9763c&scoped=true&"
import script from "./b6Step.vue?vue&type=script&lang=js&"
export * from "./b6Step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca9763c",
  null
  
)

export default component.exports